import parse from 'html-react-parser';
import { Fragment, useEffect, useRef, useState } from "react";
import { Button, Modal, Spinner, Tab } from "react-bootstrap";


import DeleteIcon from '@mui/icons-material/Delete';
import ButtonMUI from '@mui/material/Button';
import axios from "axios";
import { FaEdit } from "react-icons/fa";
import { SlArrowLeft, SlArrowRight } from "react-icons/sl";
import { toast } from 'react-toastify';
import QuestionSampleFile from '../../../download_files/Question_Sample_Files.docx';
import { BACKEND_SERVER_URL } from "../../../http/http-config";
import '../QuestionBank/QuestionBank.css';

import { Stack } from "@mui/material";
import { deleteItem, fetchQuestionByQNo, getQuizQuestions, getTotalQuizQuestionCount } from "../common-helpers/commonServices";
import QuizQuestionBankModal from "./QuizQuestionBankModal";
import SubjectAndSectionDropdown from "./SubjectAndSectionDropdown";
const QuizQuestionBank = () => {
    const childRef = useRef();
    const [selectedQuestionNumber, setSelectedQuestionNumber] = useState(1);
    const [totalQuestionInQuiz, setTotalQuestionInQuiz] = useState(0);
    const [quizQuestions, setQuizQuestions] = useState([]);
    const [correctAnswer, setCorrectAnswer] = useState('');
    const [selectedQuestion, setSelectedQuestion] = useState({});
    const [showQuestion, setShowQuestion] = useState(false);
    const [loadQuestions, setLoadQuestions] = useState(false);
    const [loadingQuestions, setLoadingQuestions] = useState(false);
    //console.log(selectedQuestion, selectedQuestionNumber, showQuestion)
    const [modalBox, setModalBox] = useState(false)
    const [selectedFile, setSelectedFile] = useState(null);
    const [questionOffset, setQuestionOffset] = useState(1);
    const [customQuestionNumber, setCustomQuestionNumber] = useState(null);
    useEffect(() => {
        setLoadingQuestions(true);
        getQuizQuestions(questionOffset).then(res => {
            setQuizQuestions((preValue) => preValue.concat(res));
            setLoadingQuestions(false);
        }
        ).catch(error => {
            setLoadingQuestions(false);
            console.log(error)
            toast.error(error.response.data.message)
        })
        getTotalQuizQuestionCount().then(res => {
            setTotalQuestionInQuiz(res);
        }).catch(error => {
            toast.error(error.response.data.message)
        })

    }, [loadQuestions])

    useEffect(() => {
        setCustomQuestionNumber(null);
        let selectedQ = quizQuestions.find(question => question.questionNumber == selectedQuestionNumber)
        if (selectedQ?.questionNumber) {
            setSelectedQuestion(selectedQ)
            setCorrectAnswer(selectedQ.correctAnswer.toLowerCase())
            setShowQuestion(true)
        } else {
            setSelectedQuestion({})
            setShowQuestion(false)
        }

    }, [selectedQuestionNumber, quizQuestions])

    const [ids, setIds] = useState({ subjectId: 0, sectionId: 0 });

    function handleUploadFile() {
        if (!ids.subjectId || !ids.sectionId) {
            toast.error("Please Select Subject and Section");
            return;
        }
        toast.info("Question paper file is being proccessed, It will take 1 minute to save quetions")
        setModalBox(false)
        let formData = new FormData();
        formData.append('uploadedFile', selectedFile, selectedFile.name);
        //  formData.append('totalQuestions', totalQuestoins);   
        console.log(formData)
        axios.post(BACKEND_SERVER_URL + `/uploadQuizQuestions/${ids.subjectId}/${ids.sectionId}`, formData)
            .then((response) => {
                if (response.data.statusCode == 200) {
                    toast.success(response.data.message);
                    setIds({ subjectId: 0, sectionId: 0 })
                }
                setLoadQuestions(!loadQuestions)
            })
            .catch(error => {
                setIds({ subjectId: 0, sectionId: 0 })
                toast.error(error.response.data.message);
            });
    }
    const loadMoreQuestions = () => {
        setQuestionOffset((previous) => (previous + 100));
        setLoadQuestions(!loadQuestions);
    }
    useEffect(() => {
        if (customQuestionNumber) {
            try {
                fetchQuestionByQNo(customQuestionNumber).then(question => {
                    setSelectedQuestion(question);
                })

            } catch (error) {
                console.log("error while fethcing question", error.message);
            }
        }
    }, [customQuestionNumber])

    return (
        <Fragment >
            <div className="card p-0 rounded-0 mb-0 ps-0">
                <div className="row gx-0 ">
                    <div className=" bg-light " style={{ flex: 3 }}>
                        {/* <div style={{ backgroundColor: "#f4f5f6" }}>
                            <ButtonMUI  className="ms-2 mt-2 mb-2" variant="outlined" color="secondary" startIcon={<SlArrowLeft size={10} />} onClick={() => navigate('/test-')} >
                                Back
                            </ButtonMUI>
                        </div> */}
                        <div className="d-flex justify-content-start mt-1 p-1">
                            {/*  <button className=" btn btn-info btn-xs " onClick={() => setModalBox(true)}> Import </button> */}
                            <button type="button" className="btn btn-dark btn-xs col-4"
                                onClick={() => childRef.current.openModal({})}
                            >
                                + Add
                            </button>
                            <input type="number" onChange={(e) => setCustomQuestionNumber(e.target.value)} placeholder='Enter QNo.' min={1} className='form-control ms-2' />
                        </div>
                        <div className="email-left-box dlab-scroll pt-2 px-1" >
                            <div className="col-sm-12 mt-0 ms-2">
                                <div className="d-flex justify-content-start flex-wrap">
                                    {quizQuestions?.map((questionBoxData, index) => (
                                        <div
                                            // style={setQuizQuestionBoxStyling()}
                                            key={questionBoxData.questionNumber} // Add key here for optimization
                                            className={` d-inline-flex justify-content-center col-2 cursor-pointer border-2 rounded-circle m-2   ${questionBoxData.questionNumber === (/* customQuestionNumber ? customQuestionNumber :  */selectedQuestionNumber) ? "bg-dark text-white" : ""}`}
                                            onClick={() => setSelectedQuestionNumber(questionBoxData.questionNumber)}
                                        >
                                            <span className="px-1 py-2 fw-bold ">  {questionBoxData.questionNumber}</span>

                                        </div>
                                    ))}
                                </div>
                            </div>
                            <button
                                className="btn btn-secondary btn-sm w-50 mt-3"
                                onClick={loadMoreQuestions} // Assuming this function is triggered when the button is clicked
                            >
                                {loadingQuestions ? <Spinner size="sm" animation="border" variant="" /> : <span>{"Load more..."}</span>}
                            </button>



                        </div>
                    </div>
                    <div className="" style={{ flex: 10 }}>
                        <div className="email-right-box ">
                            {<Tab.Container defaultActiveKey="Import">
                                <div role="toolbar" className="toolbar ms-1 ms-sm-0 ">
                                    <div className="d-flex justify-content-around align-items-center flex-wrap p-3" style={{ backgroundColor: "#ffffff", borderRadius: "10px", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)" }}>
                                        <div className="text-center px-3">
                                            <h5 className="mb-0" style={{ color: "#274065" }}>Q. No: <span style={{ color: "#198754" }}>{customQuestionNumber ?? selectedQuestionNumber}</span></h5>
                                        </div>
                                        <div className="text-center px-3">
                                            <h5 className="mb-0" style={{ color: "#274065" }}>SUBJECT: <span style={{ color: "#198754" }}>{selectedQuestion?.subject}</span></h5>
                                        </div>
                                        <div className="text-center px-3">
                                            <h5 className="mb-0" style={{ color: "#274065" }}>SECTION: <span style={{ color: "#198754" }}>{selectedQuestion?.section}</span></h5>
                                        </div>
                                        <div className="text-center px-3">
                                            <h5 className="mb-0" style={{ color: "#274065" }}>TOTAL QUESTIONS: <span style={{ color: "#198754" }}>{totalQuestionInQuiz}</span></h5>
                                        </div>
                                    </div>


                                </div>
                                <div className="col-xl-12 col-xxl-12 col-lg-12 ">
                                    <div className="card h-auto">
                                        <div className="card-footer p-2">
                                            <div className="row d-flex justify-content-between">
                                                <div className="d-flex justify-content-between">
                                                    <ButtonMUI variant="outlined" color="secondary" startIcon={<SlArrowLeft size={10} />} onClick={() => setSelectedQuestionNumber(selectedQuestionNumber - 1)}
                                                        disabled={selectedQuestionNumber == 1}>
                                                        Previous
                                                    </ButtonMUI>
                                                    <ButtonMUI variant="outlined" color="success" endIcon={<SlArrowRight size={10} />} onClick={() => setSelectedQuestionNumber(selectedQuestionNumber + 1)} disabled={selectedQuestionNumber == quizQuestions?.length}>
                                                        Next
                                                    </ButtonMUI>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-body pt-0 ">
                                            <div className="question-bank-styling " style={{ color: 'black' }}>
                                                {/*  <p className="heading text-dark">Question: {" " + selectedQuestionNumber} </p> */}
                                                <div className="d-flex ps-2 ">
                                                    <div>  <span className={` ps-2 `}>{selectedQuestion.question ? parse(selectedQuestion.question) : null}</span> </div>
                                                </div>

                                                <div className="d-flex " style={{ display: 'flex' }}>
                                                    <strong className={`${correctAnswer == 'a' && 'bg-success text-white'}`}> (A)</strong>
                                                    <span className={` ps-2 ${correctAnswer == 'a' && 'bg-success text-white'}`}> {selectedQuestion.option1 ? parse(selectedQuestion.option1) : null} </span>
                                                </div>
                                                <div className="d-flex " style={{ display: 'flex' }}>
                                                    <strong className={`${correctAnswer == 'b' && 'bg-success text-white'} `}>(B)</strong>
                                                    <span className={` ps-2 ${correctAnswer == 'b' && 'bg-success text-white'}`}>{selectedQuestion.option2 ? parse(selectedQuestion.option2) : null}</span>
                                                </div>
                                                <div className="d-flex " style={{ display: 'flex' }}>
                                                    <strong className={`${correctAnswer == 'c' && 'bg-success text-white'} `}>(C)</strong>
                                                    <span className={` ps-2 ${correctAnswer == 'c' && 'bg-success text-white'}`}>{selectedQuestion.option3 ? parse(selectedQuestion.option3) : null}</span>
                                                </div>
                                                <div className="d-flex" style={{ display: 'flex' }}>
                                                    <strong className={`${correctAnswer == 'd' && 'bg-success text-white'} `}>(D)</strong>
                                                    <span className={` ps-2 ${correctAnswer == 'd' && 'bg-success text-white'}`}>{selectedQuestion.option4 ? parse(selectedQuestion.option4) : null}</span>
                                                </div>

                                                <div className="d-flex" style={{ display: 'flex' }}>
                                                    <strong >Explanation: </strong>
                                                    <span className={` ps-2 `}>{selectedQuestion.description ? parse(selectedQuestion.option4) : null}</span>
                                                </div>

                                            </div>
                                        </div>
                                        {showQuestion && <div className="card-footer">
                                            <div className="row d-flex justify-content-between">
                                                <div className="col-md-3 d-flex justify-content-between">
                                                    <Stack direction="row" spacing={2}>
                                                        <ButtonMUI variant="outlined" color="error" startIcon={<DeleteIcon />} onClick={() => { deleteItem(selectedQuestion.sn, 'Question', '/deleteQuizQuestion/', setLoadQuestions, loadQuestions) }}>
                                                            Delete
                                                        </ButtonMUI>
                                                        <ButtonMUI variant="outlined" color="primary" endIcon={<FaEdit />} onClick={() => childRef.current.openModal(selectedQuestion)}>
                                                            Edit
                                                        </ButtonMUI>
                                                    </Stack>
                                                </div>
                                                <div className="col-md-3 d-flex justify-content-between">
                                                    <Stack direction="row" spacing={2}>
                                                        <ButtonMUI variant="outlined" color="secondary" startIcon={<SlArrowLeft size={10} />} onClick={() => setSelectedQuestionNumber(selectedQuestionNumber - 1)}
                                                            disabled={selectedQuestionNumber == 1}>
                                                            Previous
                                                        </ButtonMUI>
                                                        <ButtonMUI variant="outlined" color="success" endIcon={<SlArrowRight size={10} />} onClick={() => setSelectedQuestionNumber(selectedQuestionNumber + 1)} disabled={selectedQuestionNumber == quizQuestions?.length}>
                                                            Next
                                                        </ButtonMUI>
                                                    </Stack>
                                                </div>
                                            </div>
                                        </div>
                                        }
                                    </div>

                                </div>
                            </Tab.Container>
                            }
                        </div>
                    </div>

                </div>
            </div>
            <Modal onHide={setModalBox} show={modalBox} centered backdrop="static">
                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="exampleModalLabel">Import Question file</h5>
                        <button type="button" className="btn-close" onClick={() => setModalBox(false)}></button>
                    </div>
                    <div className="modal-body">
                        <div className="mb-3 d-block">
                            <a href={QuestionSampleFile} download="question_sample_file.docx" ><Button variant="outline-info" size='sm' title='Click here to download the sample file'>Download Sample file </Button> </a>
                        </div>
                        <div className="mb-3 d-flex justify-content-around">
                            <SubjectAndSectionDropdown setFormData={setIds} formData={ids} subjectId={ids.subjectId} sectionId={ids.sectionId} />
                        </div>
                        <div className="mb-3 d-block">
                            <label htmlFor="basic-url" className="form-label d-block">Upload file</label>
                            <input type="file" className="form-control w-100" onChange={(e) => setSelectedFile(e.target.files[0])} accept=".docx" placeholder="upload file" />
                            {selectedFile == null ? < p className='text-danger'>Please select file</p> : null}
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-danger btn-xs" onClick={() => setModalBox(false)}>Close</button>
                        <button type="button" className="btn btn-primary btn-xs" onClick={handleUploadFile}>Upload file</button>
                    </div>
                </div>
            </Modal >

            <QuizQuestionBankModal ref={childRef} setLoadQuestions={setLoadQuestions} loadQuestions={loadQuestions} />
        </Fragment >

    );
};

export default QuizQuestionBank;

